import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Link will be here: ")
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-info",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createDocument && _ctx.createDocument(...args)))
    }, " Send to google doc "),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    (_ctx.directDocURL.url.length > 0)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.directDocURL.url,
          target: "_blank"
        }, "Open created document", 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}